import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button, Spinner } from "react-bootstrap";
import { showSuccess, showError } from "../../utils/toast";
import AdminScreenHeader from "./adminScreenHeader";
import { apiPost } from "../../service/admin/apiService";
import "../../css/admin/adminClientUserLink.css";
import Loader from "../loader";
import { BsPlus } from "react-icons/bs";

const AdminClientUserLink = () => {
  const [users, setUsers] = useState([]);
  const [clients, setClients] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [linkedClients, setLinkedClients] = useState([]);
  const [clientUserLinkList, setClientUserLinkList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [savelinkLoader, setSaveLinkLoader] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const tk = localStorage.getItem("tk") || "";
  const ui = localStorage.getItem("ui") || "";

  useEffect(() => {
    getUserList();
  }, []);

  useEffect(() => {
    getClientList();
  }, [users]);

  useEffect(() => {
    if (selectedUserId !== "") {
      getClientUserLinkList();
    }
  }, [selectedUserId]);

  useEffect(() => {
    const initialLinked = clientUserLinkList
      .filter((item) => item.li != 0) //li == 0 means client not linked. If li have value other than 0 then client is linked
      .map((item) => item.ci);
    setLinkedClients(initialLinked);
  }, [clientUserLinkList]);

  const getUserList = async () => {
    const payload = {
      action: "userlist",
      to: tk,
      ui: "",
    };

    if (tk && tk !== "") {
      try {
        setShowLoader(true);
        const response = await apiPost(process.env.REACT_APP_API_URL, payload);
        if (Number(response?.errordetails?.errorcode) > 0) {
          showError(response?.errordetails?.error);
        } else if (response?.responsedetails) {
          setUsers(response?.responsedetails || []);
        }
      } catch (err) {
        console.error("Error:", err);
        showError("Something went wrong");
      } finally {
        setShowLoader(false);
      }
    }
  };

  const getClientList = async () => {
    const payload = {
      action: "clientlist",
      to: tk,
      ci: "",
    };

    if (tk && tk !== "") {
      try {
        const response = await apiPost(process.env.REACT_APP_API_URL, payload);
        if (Number(response?.errordetails?.errorcode) > 0) {
          showError(response?.errordetails?.error);
        } else if (response?.responsedetails) {
          setClients(response?.responsedetails || []);
          setTimeout(() => {
            setShowLoader(false);
          }, 3000);
        }
      } catch (err) {
        console.error("Error:", err);
        showError("Something went wrong");
      } finally {
        setShowLoader(false);
      }
    }
  };

  const getClientUserLinkList = async () => {
    setLoading(true);
    const payload = {
      action: "userclientlinklist",
      to: tk,
      ui: selectedUserId,
    };

    if (tk && tk !== "") {
      try {
        const response = await apiPost(process.env.REACT_APP_API_URL, payload);
        if (Number(response?.errordetails?.errorcode) > 0) {
          showError(response?.errordetails?.error);
          setLoading(false);
        } else if (response?.responsedetails) {
          setClientUserLinkList(response?.responsedetails);
          console.log("res11", response?.responsedetails);
          setLoading(false);
        }
      } catch (err) {
        console.error("Error:", err);
        showError("Something went wrong");
        setLoading(false);
      } finally {
        setShowLoader(false);
        setLoading(false);
      }
    }
  };

  const toggleClientLink = (clientId) => {
    setLinkedClients(
      (prev) =>
        prev.includes(clientId)
          ? prev.filter((id) => id !== clientId) // remove
          : [...prev, clientId], // add
    );
  };

  const saveLinks = async () => {
    if (savelinkLoader) return;
    if (!selectedUserId || linkedClients.length === 0) {
      showError("Fields with red asterisk can not be left blank.");
      return;
    }

    const payload = {
      action: "userclientlink",
      to: tk,
      ui: selectedUserId,
      cids: linkedClients.map((id) => ({ id: id })),
    };

    if (tk && tk !== "") {
      try {
        setSaveLinkLoader(true);
        const response = await apiPost(process.env.REACT_APP_API_URL, payload);
        if (Number(response?.errordetails?.errorcode) > 0) {
          showError(response?.errordetails?.error);
          setSaveLinkLoader(false);
        } else if (response?.responsedetails.success === "yes") {
          setTimeout(() => {
            setSaveLinkLoader(false);
          }, 3000);
          setLinkedClients([]);
          setSelectedUserId("");
          setSearchTerm("");
          showSuccess("Linked successfully!!!");
        }
      } catch (err) {
        console.error("Error:", err);
        showError("Something went wrong");
        setSaveLinkLoader(false);
      } finally {
        setSaveLinkLoader(false);
      }
    }
  };

  return (
    <>
      <Container className="pt-2 mobile-header-offset">
        <AdminScreenHeader title="📋 Client User Link" showSearch={false} />
      </Container>

      <Container
        fluid
        className="d-flex justify-content-center align-items-start mt-5"
        style={{ minHeight: "80vh" }}
      >
        <Col xs={12} sm={10} md={8} lg={6}>
          <div className="bg-white p-3 p-md-4 rounded shadow-lg">
            {/* Select User */}
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label className="text-primary">
                    Select User<span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Select
                    value={selectedUserId}
                    onChange={(e) => setSelectedUserId(e.target.value)}
                    className="text-primary"
                  >
                    <option value=""></option>
                    {users.map((user) => (
                      <option key={user.ui} value={user.ui}>
                        {`${user.fn} ${user.ln}`}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            {/* Link Clients */}
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label className="text-primary">
                    Link Clients<span style={{ color: "red" }}>*</span>
                  </Form.Label>

                  {/* Search Box */}
                  <Form.Control
                    type="text"
                    placeholder="Search Client"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="mb-3"
                  />

                  {/* Client List */}
                  <div
                    className="border rounded list-background p-2"
                    // style={{
                    //   maxHeight: "250px",
                    //   overflowY: "auto",
                    //   fontSize: "0.9rem",
                    //   backgroundColor: "#e4e274",
                    //   color: "#2c3e50",
                    // }}
                  >
                    {loading ? (
                      <div className="text-center">
                        <Spinner animation="border" size="sm" />
                      </div>
                    ) : (
                      clients
                        .filter((client) =>
                          client.na
                            .toLowerCase()
                            .includes(searchTerm.toLowerCase()),
                        )
                        .map((client) => (
                          <Form.Check
                            key={client.id}
                            type="checkbox"
                            label={client.na}
                            checked={linkedClients.includes(client.id)}
                            onChange={() => toggleClientLink(client.id)}
                            className="mb-2"
                          />
                        ))
                    )}
                  </div>
                </Form.Group>
              </Col>
            </Row>
          </div>
          {/* Save Button */}
          <div className="d-flex justify-content-end mt-3">
            <Button
              size="sm"
              onClick={() => {
                saveLinks();
              }}
            >
              <BsPlus
                style={{
                  color: "#2c3e50",
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                }}
              />
              {savelinkLoader ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Saving Link...
                </>
              ) : (
                "Save Link"
              )}
            </Button>
          </div>
        </Col>

        {/* Loader Overlay */}
        {showLoader ? <Loader show={showLoader} /> : null}
      </Container>
    </>
  );
};

export default AdminClientUserLink;
